<!--<template>
  <Menu ref="csSidebar" :active-name="menuName" :theme="theme" width="auto" :open-names="openName" accordion>
    <Submenu v-for="menu in menus" :name="menu.name">
      <template slot="title">
        <Icon :type="menu.icon"></Icon>
        {{menu.name}}
      </template>
      <MenuItem v-for="child in menu.child"  :name="menu.name+'-'+child.name" v-if="!child.hidden">
        <router-link :to='child.link' class="siderbar-link">{{child.name}}</router-link>
      </MenuItem>
    </Submenu>
    <template  v-for="menu in menus" >
      <MenuItem v-for="child in menu.child"   :name="menu.name+'-'+child.name" v-if="!child.hidden"  @click.native="leftMenuSelectedChanged(child)">
        <router-link tag="div" :to='child.link'  exact>
          <Icon :type=child.icon style="color: #ffffff;"></Icon>
          <span style="color: #ffffff;margin-left: 5px">{{child.name}}</span>
        </router-link>
      </MenuItem>
    </template>
  </Menu>
</template>
<script>
  export default {
    name: 'CsSidebar',
    props: ['menus', 'menuName', 'theme', 'openName'],
    data() {
      return {

      }
    },
    methods: {
      leftMenuSelectedChanged(menu){
        this.$emit('leftMenuSelectedChanged',menu);
      }
    },
    mounted() {
    }
  }
</script>-->

<template>
  <Menu ref="csSidebar" :active-name="menuName" :theme="theme" width="auto" :open-names="openName" accordion>
    <Submenu v-for="menu in menus" :name="menu.name" v-if="openName.length>0">
      <template slot="title">
        <Icon :type="menu.icon"></Icon>
        <span @click.stop='slide(menu)'>{{menu.name}}</span>
      </template>
	      <MenuItem v-for="child in menu.child"  :name="menu.name+'-'+child.name" :to='child.link'>
	      	{{child.name}}
	      </MenuItem>
    </Submenu>
	<MenuItem v-for="menu in menus" :name="menu.name" v-if="openName.length==0" :to='menu.link'>
			<div>
          <Icon :type=menu.icon ></Icon>
          <span style="margin-left: 5px">{{menu.name}}</span>
       </div>
	</MenuItem>
  </Menu>
</template>
<script>
  export default {
    name: 'CsSidebar',
    props: ['menus', 'menuName', 'theme', 'openName'],
    data() {
      return {}
    },
    methods: {
			slide(menu){
				this.$router.push('/assets/'+menu.id)
			}
    },
    mounted() {
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/sidebar/CsSidebar.vue